"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _ga = require("@/utils/ga");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _survey = require("@/api/survey");
var _index = _interopRequireDefault(require("../../components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SurveyList',
  components: {
    SearchBox: _index.default
  },
  filters: {
    getInternalTitle: function getInternalTitle(value) {
      // console.log('row value', value)
      return typeof value === 'undefined' ? '' : value.title;
    }
  },
  data: function data() {
    return {
      // search
      trainingStatus: _lifehikesInitData.trainingStatus,
      types: ['learning-passport', 'manager720' /*, 'hike', 'loop', 'vilt', 'other'*/],
      query: {
        page: 1,
        limit: 50,
        q: undefined,
        publish: undefined,
        type: undefined
      },
      // table
      tableLoading: false,
      surveyList: [],
      total: 0,
      // drawer
      copyDrawer: false,
      checked: {
        drawTitle: '',
        id: '',
        type: true,
        category: true,
        title: true,
        description: true,
        accessMethod: true,
        accessKey: true,
        iconImg: true,
        iconDisableImg: true,
        backgroundColor: true,
        timesTake: true,
        pages: true
        // equations: true,
        // belongToHike: true,
        // mailList: true,
      }
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.getList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    checkPermission: _permission.default,
    sort: function sort(data) {
      var prop = data.prop,
        order = data.order;
      if (prop === 'title') {
        order === 'ascending' ? this.query.sort = '+title' : this.query.sort = '-title';
      }
      if (prop === 'publish') {
        order === 'ascending' ? this.query.sort = '+publish' : this.query.sort = '-publish';
      }
      if (prop === 'createdAt') {
        order === 'ascending' ? this.query.sort = '+createdAt' : this.query.sort = '-createdAt';
      }
      if (prop === 'updatedAt') {
        order === 'ascending' ? this.query.sort = '+updatedAt' : this.query.sort = '-updatedAt';
      }
      this.search(1);
    },
    search: function search(pageNo) {
      this.query.page = pageNo;
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      this.query.publish = this.query.publish === '' ? undefined : this.query.publish;
      this.query.type = this.query.type === '' ? undefined : this.query.type;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _log.showDebugLog)('Survey query', this.query);
      (0, _survey.getSurveyList)(token, this.query).then(function (response) {
        (0, _log.showDebugLog)('Survey-Search-response', response);
        _this2.surveyList = response.data.rows;
        _this2.total = response.data.count;
        _this2.tableLoading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('Survey-Search-error', error);
        _this2.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response })
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    // copy
    openDrawer: function openDrawer(id, title) {
      this.copyDrawer = true;
      this.checked.drawTitle = "Copy a New Survey from [".concat(title, " (").concat(id, ")]");
      this.checked.id = id;
    },
    handleDrawClose: function handleDrawClose(done) {
      this.$confirm('Are you sure you want to stop copy?').then(function (_) {
        done();
      }).catch(function (_) {});
    },
    copy: function copy() {
      var link = "/survey/createfromcopy?" + "fromId=".concat(this.checked.id, "&") + "type=".concat(this.checked.type, "&") + "c=".concat(this.checked.category, "&") + "t=".concat(this.checked.title, "&") + "d=".concat(this.checked.description, "&") + "am=".concat(this.checked.accessMethod, "&") + "ak=".concat(this.checked.accessKey, "&") + "ii=".concat(this.checked.iconImg, "&") + "idi=".concat(this.checked.iconDisableImg, "&") + "bc=".concat(this.checked.backgroundColor, "&") + "tt=".concat(this.checked.timesTake, "&") + "p=".concat(this.checked.pages);
      this.$router.push(link);
    },
    // delete
    deleteSurvey: function deleteSurvey(id, title) {
      var _this3 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var oEmail = (0, _cookie.getCookie)('EMAIL');
      this.$confirm("This will delete [ ".concat(title, " ]. Continue?"), 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        // var data = { publish: 'markdelete' }
        // updateHikeById(token, id, data).then(response => {
        //   this.search(this.query.page)
        //   const msg = 'Survey is deleted'
        //   displayPopupMessage(msg, 'success')
        //   writeGaEvent(this, 'Hike', `${userEvent.survey.delete}`, oEmail, `Survey Id: ${id}`)
        // }).catch((error) => {
        //   displayPopupMessage(error, 'error')
        // })
        (0, _survey.deleteSurveyById)(token, id).then(function (response) {
          _this3.search(_this3.query.page);
          var msg = 'Survey is deleted';
          (0, _log.displayPopupMessage)(msg, 'success');
          (0, _ga.writeGaEvent)(_this3, 'Hike', "".concat(_lifehikesInitData.userEvent.survey.delete), oEmail, "Survey Id: ".concat(id));
        }).catch(function (error) {
          (0, _log.displayPopupMessage)(error, 'error');
        });
      }).catch(function () {
        var msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    disableVisble: function disableVisble(id) {
      this.$refs[id].visible = false;
    }
  }
};